import {useTranslation} from "react-i18next";
import {withStyles} from "@mui/styles";
import {connect} from "react-redux";
import {CircularProgress, Grid, Typography} from "@mui/material";
import {Profile} from "../User/userDTO";
import {useEffect} from "react";
import styles from "./PlanPage-jss";
import {Dispatch} from "redux";
import Page from "../../components/Page/Page";
import {useNavigate} from "react-router-dom";
import useGTM from "../../packages/useGTM/useGTM";

type Properties = {
    classes: any,
    profile: Profile,
}

function SubscriptionCancelPage(props: Properties) {
    const {
        classes,
        profile,
    } = props;

    const {t} = useTranslation();
    const navigate = useNavigate();
    const gtm = useGTM({profile});

    useEffect(() => {
        const trackAndRedirect = async () => {
            // Track cancellation event
            await gtm.trackEvent('plan_subscription_cancelled', {
                action: 'checkout_cancelled',
            });

            // Redirect to plan page after tracking
            // Small delay to ensure event is sent
            setTimeout(() => {
                navigate('/plan');
            }, 500);
        };

        trackAndRedirect();
    }, []);

    return (
        <Page desc="" title={t('Subscription Cancelled')}>
            <Grid container direction="column" spacing={5} alignItems="center">
                <Grid item container alignItems="center" direction="column" spacing={3} xs={12}>
                    <Grid item xs={12} alignItems="center">
                        <CircularProgress />
                    </Grid>
                    <Grid item xs={12}>
                        <Typography variant="h5" component="div" align="center">
                            {t('Subscription cancelled')}
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography variant="body1" component="div" align="center" color="text.secondary">
                            {t('Redirecting you back to plans...')}
                        </Typography>
                    </Grid>
                </Grid>
            </Grid>
        </Page>
    );
}

const mapStateToProps = function (state: any) {
    return {
        profile: state.user.profile,
    }
}

function mapDispatchToProps(dispatch: Dispatch) {
    return {};
}

export default withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(SubscriptionCancelPage));

